import styled from "styled-components";

import { Box, Flow, Stream, Button, Text as Tx, } from "@bracket/ui";
import { TokenAmountOutput, } from "@bracket/platform/components";
import { useSwap, } from "@bracket/platform/store";



export declare type SwapOutputProps = {
	inputName?: string;
	disabled?: boolean;
	showUSD?: boolean;
};



/**
 * SwapOutput component displays the output token information in a swap interface.
 * Shows token balance, USD value, and allows for max output selection.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.inputName] - Optional label for the output section
 * @param {boolean} [props.disabled=false] - Whether the output is disabled
 * @param {boolean} [props.showUSD=true] - Whether to show USD value
 * @returns {JSX.Element} Output section of swap interface
 */
export const SwapOutput = ({ inputName, disabled = false, showUSD = true, }: SwapOutputProps) => {

	const { outputBalance, tokenOut, swapValueUSD, } = useSwap();

	return (
		<Brace>
			{inputName && (
				<InputLabels>
					<Tx>{inputName}</Tx>
					{ !disabled && outputBalance && <Button variant="text" onClick={() => { }} label="Max" /> }
				</InputLabels>
      )}

			<div>
				<TokenAmountOutput disabled={disabled} />
				<BalanceContainer>
					<DetailLeft><Tx sm color="subheading">Balance: {outputBalance} {tokenOut.symbol}</Tx></DetailLeft>
					<DetailRight>{ showUSD && <Tx sm color="subheading">USD: {swapValueUSD}</Tx> }</DetailRight>
				</BalanceContainer>
			</div>
		</Brace>
	);	
};

const Brace = styled(Flow)`
	gap: 0rem;
`


const BalanceContainer = styled(Stream)`
	justify-content: space-between;
	margin: 0.25rem 0;
	@media (min-width: 1024px) {
		margin: 0.5rem 0;
	}
`;

const InputLabels = styled(Box)`
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
`;

const DetailRight = styled(Flow)`
	justify-content: space-between;
	align-items: flex-end;
`;

const DetailLeft = styled(Stream)`
	justify-content: space-between;
`;
